import { compact } from '@lglp/utils';
import { is, prop } from 'ramda';

import { COMMON } from 'translations';

import { HTTP_CLIENT_ERROR_NOT_FOUND } from './http';

// We suppose that if a message contains only uppercase chars and underscore, it's a translation key
const isTranslatableMessage = (m) => m.match(/[A-Z_]+/);

const translatable = (m, t, error) => {
  if (isTranslatableMessage(m)) {
    return t(m, prop('context', error));
  }

  return m;
};

const getErrorMessage = (t, error) => {
  return translatable(prop('message', error), t, error);
};

const MESSAGES = {
  [HTTP_CLIENT_ERROR_NOT_FOUND]: COMMON.ERROR_NOT_FOUND,
};

const getErrorMessageFromStatus = (t, error) => {
  const status = error?.status;
  return translatable(MESSAGES[status] || COMMON.ERROR_DEFAULT, t, error);
};

export const getErrorObject = (error, message, ctx = {}) => {
  return compact({
    status: getStatus(error),
    message: message,
    context: ctx,
    raw: error?.message ? error.message : error,
    error,
  });
};

export const getStatus = (error) => error?.status || 'Error';

export const getMessage = (t, error) => {
  if (is(String, error)) {
    return error;
  }

  if (error?.message && !(error instanceof TypeError)) {
    return getErrorMessage(t, error);
  }

  if (error?.status) {
    return getErrorMessageFromStatus(t, error);
  }

  /* istanbul ignore next */
  if (process.env.RAZZLE_ENV !== 'prod') {
    // eslint-disable-next-line
    console.error(error);
  }

  return is(Function, t) ? t(COMMON.ERROR_DEFAULT) : 'Unexpected error';
};

export class ExtendableError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    /* istanbul ignore next */
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export default (status, message, title = undefined, ctx = {}) => ({
  status,
  message,
  context: ctx,
  title: title ? title : status,
});
